(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/tracking/swedbank-express-track.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/tracking/swedbank-express-track.js');

'use strict';

const logger = svs.accountservicesReact.deposit.swedbankExpress.logger;
const backendErrorCodes = svs.accountservicesReact.deposit.constants.swedbankExpress.backendErrorCodes;
const category = 'Deposits';
const paymentType = 'SwedbankExpress';

const trackConsentOk = () => {
  logger.debug('trackConsentOk...');
  svs.components.analytics.trackEvent({
    category,
    action: 'Consent Success',
    opt_label: paymentType,
    opt_value: 0
  });
};

const trackDepositOk = (err, result) => {
  logger.debug('trackDepositOk...');
  if (!err) {
    logger.debug("trackDepositOk, depositamount: ".concat(result ? result : 0));
    svs.components.analytics.trackEvent({
      category,
      action: 'Deposit Success',
      opt_label: paymentType,
      opt_value: parseInt(result, 10) ? parseInt(result, 10) : 0
    });
  } else {
    logger.info('ERROR getting amount from session, using 0kr');
    svs.components.analytics.trackEvent({
      category,
      action: 'Deposit Success',
      opt_label: paymentType,
      opt_value: 0
    });
  }
};

const translateErrorCode = expressErrorCode => {
  let errorCode = expressErrorCode;
  switch (expressErrorCode) {
    case backendErrorCodes.GENERAL_ERROR:
      errorCode = expressErrorCode;
      break;
    case backendErrorCodes.TRY_AGAIN:
      errorCode = expressErrorCode;
      break;
    case backendErrorCodes.MISSING_TOKEN:
      errorCode = expressErrorCode;
      break;
    case backendErrorCodes.EXPIRED_REFRESH_TOKEN:
      errorCode = expressErrorCode;
      break;
    case backendErrorCodes.CUSTOMER_HAS_MULTIPLE_BANKS:
      errorCode = expressErrorCode;
      break;
    case backendErrorCodes.DEPOSIT_ABOVE_LIMIT:
      errorCode = 1033;
      break;
    case backendErrorCodes.DEPOSIT_BELOW_LIMIT:
      errorCode = 1131;
      break;
    case backendErrorCodes.DEPOSIT_BUDGET_NOT_SET:
      errorCode = 100031;
      break;
    case backendErrorCodes.DEPOSIT_DAY_LIMIT_EXCEEDED:
      errorCode = 100033;
      break;
    case backendErrorCodes.DEPOSIT_WEEK_LIMIT_EXCEEDED:
      errorCode = 100034;
      break;
    case backendErrorCodes.DEPOSIT_MONTH_LIMIT_EXCEEDED:
      errorCode = 100035;
      break;
    case backendErrorCodes.DEPOSIT_SUSPENDED:
      errorCode = 100037;
      break;
    case backendErrorCodes.NOT_A_CUSTOMER_IN_SWD_GROUP:
      errorCode = expressErrorCode;
      break;
    case backendErrorCodes.NOT_A_CUSTOMER_IN_SWD_SUBSIDIARY:
      errorCode = expressErrorCode;
      break;
    case backendErrorCodes.USER_CONTACT_SWEDBANK:
      errorCode = expressErrorCode;
      break;
    case backendErrorCodes.INSUFFICIENT_FUND:
      errorCode = expressErrorCode;
      break;
    default:
      logger.debug("trackDeposit, translateErrorCode, could not find error code use Express code: ".concat(expressErrorCode));
  }
  logger.debug("translateErrorCode expressErrorCode: ".concat(expressErrorCode, ", out GA code:  ").concat(errorCode));
  return errorCode;
};

const trackConsentError = expressErrorCode => {
  logger.debug('trackConsentError...');
  const errorCode = translateErrorCode(expressErrorCode);
  svs.components.analytics.trackEvent({
    category,
    action: 'Consent Failure',
    opt_label: paymentType,
    opt_value: errorCode
  });
};

const trackConsentRetries = expressErrorCode => {
  logger.debug('trackConsentRetries...');
  const errorCode = translateErrorCode(expressErrorCode);
  svs.components.analytics.trackEvent({
    category,
    action: 'Consent Retry',
    opt_label: paymentType,
    opt_value: errorCode
  });
};

const trackDepositError = expressErrorCode => {
  logger.debug('trackDepositError...');
  const errorCode = translateErrorCode(expressErrorCode);
  svs.components.analytics.trackEvent({
    category,
    action: 'Deposit Failure',
    opt_label: paymentType,
    opt_value: errorCode
  });
};
svs.accountservicesReact.deposit.tracking.swedbankExpressTrack = {
  trackDepositOk,
  trackConsentOk,
  trackConsentError,
  trackConsentRetries,
  trackDepositError
};

 })(window);